import React, { useState } from "react";
import { toast } from "sonner";
import { submitAdvisory, extractErrorMessage } from "@/lib/api";
import { ADVISORY_FORM } from "@/constants/testIds";
import Reveal from "../sections/Reveal";

const TYPES = [
  "Clarity Sprint",
  "90-Day Arc",
  "Advisory Circle",
  "Fractional CTO/CIO",
  "Not sure",
];

export default function AdvisoryForm() {
  const [form, setForm] = useState({
    name: "",
    company: "",
    engagement_type: "90-Day Arc",
    situation: "",
    email: "",
  });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await submitAdvisory(form);
      setStatus("success");
      toast.success("Inquiry received.");
      setForm({
        name: "",
        company: "",
        engagement_type: form.engagement_type,
        situation: "",
        email: "",
      });
    } catch (err) {
      setStatus("error");
      const msg = extractErrorMessage(err);
      setErrorMsg(msg);
      toast.error(msg);
    }
  };

  return (
    <form data-testid={ADVISORY_FORM.root} onSubmit={onSubmit} noValidate className="flex flex-col gap-6">
      <Reveal>
        <div>
          <label htmlFor="a-name" className="rk-label">Name</label>
          <input id="a-name" type="text" required
            data-testid={ADVISORY_FORM.nameInput}
            value={form.name} onChange={update("name")}
            className="rk-field" placeholder="Your name"
          />
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <div>
          <label htmlFor="a-company" className="rk-label">Company</label>
          <input id="a-company" type="text" required
            data-testid={ADVISORY_FORM.companyInput}
            value={form.company} onChange={update("company")}
            className="rk-field" placeholder="Company / organization"
          />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div>
          <label htmlFor="a-email" className="rk-label">Email</label>
          <input id="a-email" type="email" required
            data-testid={ADVISORY_FORM.emailInput}
            value={form.email} onChange={update("email")}
            className="rk-field" placeholder="you@company.com"
          />
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div>
          <label htmlFor="a-type" className="rk-label">Type of engagement</label>
          <select id="a-type"
            data-testid={ADVISORY_FORM.typeSelect}
            value={form.engagement_type}
            onChange={update("engagement_type")}
            className="rk-field rk-select"
          >
            {TYPES.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div>
          <label htmlFor="a-situation" className="rk-label">Where you are / what you&apos;re facing</label>
          <textarea id="a-situation" required
            data-testid={ADVISORY_FORM.situationTextarea}
            value={form.situation} onChange={update("situation")}
            className="rk-textarea"
            placeholder="Three lines is plenty. Be specific about the decision in front of you."
          />
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="flex flex-wrap items-center gap-4 pt-2">
          <button type="submit" disabled={status === "loading"}
            data-testid={ADVISORY_FORM.submit}
            className="rk-btn-primary"
          >
            {status === "loading" ? "Sending…" : "Send inquiry"}
          </button>
          <span className="rk-caption">
            Rakia reviews all inquiries personally. You will hear back within 3
            business days.
          </span>
        </div>
      </Reveal>
      {status === "success" && (
        <div data-testid={ADVISORY_FORM.success}
          style={{ paddingTop: 14, borderTop: "1px solid var(--rk-copper)", fontSize: 15 }}>
          Inquiry received. Rakia will reach out directly.
        </div>
      )}
      {status === "error" && (
        <div data-testid={ADVISORY_FORM.error} style={{ color: "var(--rk-danger)", fontSize: 14 }}>
          {errorMsg}
        </div>
      )}
    </form>
  );
}
